module.exports = __webpack_public_path__ + "img/google.c2315134.svg";